import { app } from '../../../../../app';

app.component('confirmRemoveDropboxProvisioningMapping', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-remove-mapping.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/confirm-remove-mapping/confirm-remove-mapping.component.js